<template>
  <el-dialog :visible.sync="show" :title="name" width="900px">
    <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-form-item prop="platformId" label="场站">
        <el-select v-model="data.platformId" placeholder="选择场站" clearable filterable style="width: 100%">
          <el-option v-for="(item, index) in platformList" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="tenantId" label="企业">
        <el-select v-model="data.tenantId" placeholder="选择企业" clearable filterable style="width: 100%">
          <el-option v-for="(item, index) in tenantList" :key="index" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      name: '',
      data: {},
      rules: {
        platformId: [{ required: true, trigger: 'change', message: '选择场站' }],
        tenantId: [{ required: true, trigger: 'change', message: '选择企业' }]
      },
      loading: false,
      platformList: [],
      tenantList: []
    }
  },
  methods: {
    display() {
      this.show = true
      this.data = {
        platformId: '',
        tenantId: ''
      }
      this.name = '绑定场站主企业'
      this.getPlatformList()
      this.getTenantList()
    },

    getPlatformList() {
      this.$axios.get('/account/platform/all').then(res => {
        this.platformList = res.data.data
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }).catch(err => {
        console.log('数据库列表错误：', err)
      })
    },

    getTenantList() {
      this.$axios.get('/account/tenant/all').then(res => {
        this.tenantList = res.data.data
      }).catch(() => {
      })
    },

    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = JSON.parse(JSON.stringify(this.data))
          this.$axios.post('/account/platform/PlatformBindMainTenant', params).then(() => {
            this.$message.success('绑定成功')
            this.show = false
            this.$emit('init')
            this.loading = false
          }).catch(err => {
            console.log('绑定失败', err)
            this.loading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
